/**
 * Install once at app boot: any 401 from our Chat backend means the session is invalid
 * (deleted account / expired token). Dispatch account-deleted so ProtectedRoute can logout.
 * Scoped to REACT_APP_BACKEND_URL only — ignores Yahoo/POC/Stripe/etc.
 */
export function installAccountDeletedInterceptor(): void {
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  if (!backendUrl || typeof window === "undefined" || (window as any).__accountDeletedInterceptorInstalled) {
    return;
  }
  (window as any).__accountDeletedInterceptorInstalled = true;

  const originalFetch = window.fetch.bind(window);

  window.fetch = async (...args: Parameters<typeof fetch>): Promise<Response> => {
    const response = await originalFetch(...args);

    try {
      const requestInfo = args[0];
      const url =
        typeof requestInfo === "string"
          ? requestInfo
          : requestInfo instanceof Request
            ? requestInfo.url
            : String(requestInfo);

      if (response.status === 401 && url.startsWith(backendUrl)) {
        window.dispatchEvent(new CustomEvent("account-deleted"));
      }
    } catch {
      // Never break the original fetch flow
    }

    return response;
  };
}
